import type { FactoryOpts } from "imask";
import { useEffect } from "react";
import { useIMask } from "react-imask";

import { Input as BaseInput } from "@base-ui/react/input";
import { mergeRefs } from "@frontend/utils/mergeRefs";

import type { InputProps } from "./Input.types";

type MaskedInputProps = Omit<
  InputProps,
  "mask" | "size" | "variant" | "invalid" | "success"
> & { mask: FactoryOpts };

export function MaskedInput({
  mask,
  value,
  defaultValue,
  onValueChange,
  ref,
  ...props
}: MaskedInputProps) {
  const {
    ref: maskRef,
    value: maskValue,
    setValue,
  } = useIMask(mask, {
    defaultValue: value ?? defaultValue,
    onAccept: (nextValue) => onValueChange?.(String(nextValue)),
  });

  useEffect(() => {
    if (value !== undefined && value !== maskValue) {
      setValue(value);
    }
  }, [value, maskValue, setValue]);

  return <BaseInput ref={mergeRefs(maskRef, ref)} {...props} />;
}
